import { useContext } from 'react';

import { AuthContext, type ContextoAuth } from '@/features/auth/AuthProvider';

export function useAuth(): ContextoAuth {
  const contexto = useContext(AuthContext);
  if (!contexto) {
    throw new Error('useAuth precisa estar dentro de <AuthProvider>');
  }
  return contexto;
}
